var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.orderInfoItem }, [
    _c("div", { class: _vm.$style.orderInfoLabel }, [
      _c("div", { class: _vm.$style.orderInfoImage }, [
        _c("svg", {
          directives: [{ name: "svg", rawName: "v-svg" }],
          class: _vm.$style.orderInfoIcon,
          attrs: { symbol: _vm.data.icon }
        })
      ]),
      _vm._v(" "),
      _c("h6", [_vm._v(_vm._s(_vm.data.title))])
    ]),
    _vm._v(" "),
    _c("p", { class: _vm.$style.orderInfoData }, [
      _vm._v(_vm._s(_vm.data.value))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/OrderField.vue?vue&type=template&id=25dd9e7c&
// module id = null
// module chunks = 